'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import type { TDynamicData } from '../../types/dynamic-data';

export function PartnersCarousel({ partners }: { partners: TDynamicData[] }) {
  const items = [...partners, ...partners, ...partners];

  return (
    <section
      className={cn(
        'custom-section',
        'px-0 pb-16 pt-8 sm:pb-20 sm:pt-10 md:pb-24 md:pt-14 lg:pb-48 lg:pt-16 xl:pb-[216px] xl:pt-[72px]',
      )}
    >
      <div className="w-full overflow-hidden">
        <div
          className={cn('flex gap-6', 'w-max', 'animate-partners-scroll', 'will-change-transform')}
        >
          {items.map((partner, index) => (
            <div
              key={index}
              className={cn(
                'flex flex-shrink-0 items-center justify-center border bg-white',
                'max-h-[80px] min-h-[80px] min-w-[106px] max-w-[106px] p-4',
                'sm:max-h-[94px] sm:min-h-[94px] sm:min-w-[125px] sm:max-w-[125px] sm:p-5',
                'md:max-h-[120px] md:min-h-[120px] md:min-w-[160px] md:max-w-[160px] md:p-8',
                'lg:max-h-[165px] lg:min-h-[165px] lg:min-w-[220px] lg:max-w-[220px] lg:p-10',
                'ea-partners-carousel__partner-card',
              )}
            >
              <Image
                src={partner.image?.url || '/images/placeholder.png'}
                alt={resolveImageAlt(partner?.image, partner?.name)}
                width={160}
                height={120}
                className="h-full w-full object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
